import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {DxGridToolbarButton} from "./dx-grid-toolbar-button";

/** Опции панели инструментов списка. */
@jsonObject
export class DxGridToolbarOptions {
  @jsonArrayMember(DxGridToolbarButton, {name: "buttons", emitDefaultValue: false, isRequired: false })
  private _buttons: DxGridToolbarButton[] = [];

  get buttons(): DxGridToolbarButton[] {
    return this._buttons;
  }

  set buttons(value: DxGridToolbarButton[]) {
    this._buttons = value;
  }
}
